import { render, staticRenderFns } from "./channel.product.demo.vue?vue&type=template&id=4e7f1f7d&"
import script from "./channel.product.demo.vue?vue&type=script&lang=js&"
export * from "./channel.product.demo.vue?vue&type=script&lang=js&"
import style0 from "./channel.product.demo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "channel.product.demo.vue"
export default component.exports